module.exports = __webpack_public_path__ + "static/media/FLV.5bf968e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/FLV.svg
// module id = 1700
// module chunks = 17